import { RootActionTypes } from '@redux/modules/actionTypes';
import { RootActions } from 'types/state';
import * as ActionTypes from './actionTypes';
import { LoginFailureError } from './actions';

export interface AuthenticationState {
  authenticated: boolean
  token: string | null
  error: LoginFailureError[]
  showSessionWarning: boolean
  /** This is the last time the user logged into the system. */
  lastLogin: string | null
  /** This is the last time the session of the user is refreshed. This is not
   * the same as lastLogin. */
  lastSessionRenewed: Date | null
}

export const initialState: AuthenticationState = {
  authenticated: false,
  token: null,
  error: [],
  showSessionWarning: false,
  lastLogin: null,
  lastSessionRenewed: null,
};

/**
 * Defines the authentication sub-state for the application.
 */
const reducer = (
  state: AuthenticationState = initialState,
  action: RootActions
): AuthenticationState => {
  switch (action.type) {
    case ActionTypes.SHOW_SESSION_WARNING:
      return {
        ...state,
        showSessionWarning: true,
      };

    case ActionTypes.HIDE_SESSION_WARNING:
      return {
        ...state,
        showSessionWarning: false,
      };

    case ActionTypes.FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: true,
        error: [],
        token: action.payload.token,
        lastLogin: action.payload.lastLogin,
        lastSessionRenewed: action.payload.lastSessionRenewed,
      };

    case RootActionTypes.api.FETCH_STATUS_FAILURE:
      return {
        ...state,
        authenticated: false,
      };

    case ActionTypes.FETCH_LOGIN_FAILURE:
      return {
        ...state,
        authenticated: false,
        error: [...action.payload.errors],
      };

    case ActionTypes.FETCH_RENEW_SESSION_SUCCESS:
      return {
        ...state,
        lastSessionRenewed: action.payload,
        showSessionWarning: false,
      };

    case RootActionTypes.api.FETCH_STATUS_SUCCESS:
      return {
        ...state,
        authenticated: true,
        lastLogin: action.payload.lastLogin,
      };

    case ActionTypes.LOGGED_OFF:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
